export default __webpack_public_path__ + "static/media/Basic_Forge.c682d308.jpeg";